/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { repeatMobileOrderComboSchema } from "./repeatMobileOrderComboSchema.ts";
import { repeatMobileOrderItemSchema } from "./repeatMobileOrderItemSchema.ts";

export const repeatMobileOrderSchema = z.object({
	items: z.array(repeatMobileOrderItemSchema).optional(),
	combos: z.array(repeatMobileOrderComboSchema).optional(),
	comment: z.string().nullish(),
});
